export default "__VITE_ASSET__BKOSA$2K__"